export default function isMobilePhoneNumber(telephoneNumber: string) {
  return ['01', '491', '+491', '00491'].some((prefix) => telephoneNumber.startsWith(prefix));
}
